import { render, staticRenderFns } from "./orderSuccess.vue?vue&type=template&id=58589287&scoped=true&"
import script from "./orderSuccess.vue?vue&type=script&lang=js&"
export * from "./orderSuccess.vue?vue&type=script&lang=js&"
import style0 from "./orderSuccess.vue?vue&type=style&index=0&id=58589287&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58589287",
  null
  
)

export default component.exports